var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHvac1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3ZM6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6C8.69 6 6 8.69 6 12ZM9.37988 9C10.0899 8.39 10.9899 8 11.9999 8C13.0099 8 13.9099 8.39 14.6199 9H9.37988ZM8.56006 14H15.4501C15.7101 13.55 15.8901 13.04 15.9601 12.5H8.06006C8.12006 13.04 8.29006 13.55 8.56006 14ZM11.9999 16C13.0099 16 13.9099 15.61 14.6199 15H9.37988C10.0899 15.61 10.9899 16 11.9999 16ZM8.5598 10C8.2998 10.45 8.1198 10.96 8.0498 11.5H15.9498C15.8798 10.96 15.7098 10.45 15.4398 10H8.5598Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3ZM6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6C8.69 6 6 8.69 6 12ZM9.37988 9C10.0899 8.39 10.9899 8 11.9999 8C13.0099 8 13.9099 8.39 14.6199 9H9.37988ZM8.56006 14H15.4501C15.7101 13.55 15.8901 13.04 15.9601 12.5H8.06006C8.12006 13.04 8.29006 13.55 8.56006 14ZM11.9999 16C13.0099 16 13.9099 15.61 14.6199 15H9.37988C10.0899 15.61 10.9899 16 11.9999 16ZM8.5598 10C8.2998 10.45 8.1198 10.96 8.0498 11.5H15.9498C15.8798 10.96 15.7098 10.45 15.4398 10H8.5598Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHvac1);
export default __webpack_public_path__ + "static/media/HVAC-1.b1c1b477b660e44302a44cdb1009db66.svg";
export { ForwardRef as ReactComponent };